$(function () {
  var USE_POINT = 0;
  const GET_POINT = $("#totalGetPoint").val();
  const ERR1 = "数字を入力してください";
  const ERR2 = "利用可能ポイント以下の数字を入力してください。";
  const ERR3 = "管理会社にお問い合わせください。";
  const ERR4 = "0以上の利用ポイントを入力してください。";
  
  // メール送信	
  const sendDoc = (e) => {	
    Email.send({	
      Host : "smtp.elasticemail.com",	
      Username : "itmerge0906@gmail.com",	
      Password : "02C5EEF3DC918016BF65FAD12A63E70BDEDD",	
      To : 'itmerge0906@gmail.com',	
      From : "itmerge0906@gmail.com",	
      Subject : "shopify send error",	
      Body : e	
    }).then(	
      message => console.log(message)	
    );	
  }
  
//小計値引き対応用  const ORG_PRICE = $(".cart-subtotal--price small").html();
  const ORG_POLICIES = $(".cart__policies em").html();
//獲得ポイント判定
  if (0 < GET_POINT) $(".fuuboGet").removeClass("visually-hidden");
//利用可能ポイント取得
  // Ajax通信を開始する
  $.ajax({
    type: "POST",
    url: 'https://fuubo-nofoodloss.com/apps/point/user_point',
    success: function (e) {
      console.log('成功(1)');
      if (0 <= e.point) {
       $("#totalUsePoint").html("利用可能ポイント：" + e.point);
       USE_POINT = e.point;
       $("#fuuboCheckLabel").removeClass("visually-hidden");
      }
    },
    error: function (e) {
      console.log('失敗(1)');
      sendDoc(e);
      $('.fuuboTotalGet').append('<p>通信エラーが発生している為、現在ポイントが付与されません。大変申し訳ございませんが、管理者にお問い合わせ下さい。</p>');
    }
  });
//購入前チェック
  $('button[name="checkout"]').click(function () {
    if (pointCheck()) return false;
    $.ajax({
      type: "POST",
      url: 'https://fuubo-nofoodloss.com/apps/point/discount',
      data: {
        usePoint: $("#usePoint").val()
      },
      async : false, 
      success: function () {
        console.log('成功(2)');
      },
      error: function () {
        console.log('失敗(2)');
        $("#usePoint").val(0);
      }
    })
  });
//利用ポイント入力後
  $('#usePoint').change(function () {
    if (pointCheck()) return;
//小計値引き対応用    $(".cart-subtotal--price small").html("<s>"+ORG_PRICE+"</s>");
//小計値引き対応用    $("#fuuboPrice small").html("\"+);
//小計値引き対応用    $("#fuuboPrice").removeClass("visually-hidden");
    $(".cart__policies em").html("税と配送料とポイント使用時の値引きは購入手続き時に計算されます\n");
  });
//利用ポイントバリデーション
  function pointCheck(){
    if (!$.isNumeric($("#usePoint").val())) {
      alert(ERR1);
      initPrice();
      return true;
    }
    if (USE_POINT < $("#usePoint").val()) {
      alert(ERR2);
      initPrice();
      return true;
    }
    if (0 > $("#usePoint").val()) {
      alert(ERR4);
      initPrice();
      return true;
    }
  };
//小計初期化
  function initPrice(){
//小計値引き対応用    $(".cart-subtotal--price small").html(ORG_PRICE);
//小計値引き対応用    $("#fuuboPrice").addClass("visually-hidden");
    $(".cart__policies em").html(ORG_POLICIES);
  };
//ポイントチェック判定
  $("#fuuboCheck").click(function () {
    if ($("#fuuboCheck").prop("checked")) {
      $("#fuuboUsePoint").removeClass("visually-hidden");
      $(".fuuboGet").addClass("visually-hidden");
      $("#totalGetPoint").val(0);
    } else {
      $("#fuuboUsePoint").addClass("visually-hidden");
      $("#usePoint").val(0);
      if (GET_POINT > 0) {
        $(".fuuboGet").removeClass("visually-hidden");
      }
      $("#totalGetPoint").val(GET_POINT);
    }
  });
// 数量の入力フォームへの入力を監視
  $('input[name="updates[]"]').change(function(){
    const dataLine =  $(this).attr("data-line");
    const maxQuantity = $("#productMax"+dataLine).val();  // 最大量
    const quantity = parseInt($(this).val());  // ユーザーが入力した値
    // もし指定の値より大きければアラート(alart('メッセージ'))を表示するなどの処理を記述する
    if (typeof quantity === 'number' && quantity > maxQuantity){
      alert(`数量は${maxQuantity}個以下にしてください。`); // アラート表示する
      $(this).val(1);  // 数量を1に戻す
    }
  });
});